<template>
  <div class="card shadow mb-5">
    <div class="card-body">

      <h4>{{ $t('Booking') }}</h4>

      <slot></slot>

      <div class="mt-5">
        <button type="button" class="btn btn-primary btn-block"
                v-on:click.prevent="$emit('submit')"
                :disabled="disableSubmit">
          {{ $t('Book now') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookingCard",
  props: {
    disableSubmit: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>